const menu = [
    {
        name: '会员信息',
        link: '',
        children: [
            {
                name: '会员维护',
                link: '/layout/update-member-info',
                currentMenuLink: '/layout/update-member-info',
            },
            {
                name: '修改密码',
                link: '/layout/update-pass',
                currentMenuLink: '/layout/update-pass',
            },
        ]
    },
    {
        name: '会员风采',
        link: '',
        children: [
            {
                name: '上传会员风采',
                link: '/layout/upload-city-style',
                currentMenuLink: '/layout/upload-city-style',
            },
            {
                name: '我的会员风采',
                link: '/layout/my-city-style',
                currentMenuLink: '/layout/my-city-style',
            },
        ]
    },
    {
        name: '活动报名',
        link: '/layout/event-rigister',
        currentMenuLink: '/layout/event-rigister',
        children: []
    }
];

export default menu;
